<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>warning</v-icon> Advertencia
      </v-card-title>
      <v-card-text>
        <h3>¿Desea enviar la programación?</h3>
        <br />
        <h4>Nota: Esta acción es irreversible</h4>
        <v-layout wrap>
          <v-flex xs12>
            <v-textarea
              class="text-field-reducido-border"
              v-model="form.observacion"
              rows="2"
              auto-grow
              label="Justificación del envio"
              :rules="$validate(['required'])"
              required
              outline
              clearable
            >
            </v-textarea>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="close()"> Cancelar </v-btn>
        <v-btn
          color="success"
          @click.prevent="enviarProgramacion()"
          :loading="loading"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  mixins: [validate],
  props: ["item"],
  data() {
    return {
      user: this.$storage.get("user"),
      dialog: false,
      form: {},
      loading: false,
      justificacion_rechazo: null,
      id: null,
      bandera_justificacion: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogEnviarProgramacion", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.form = {};
      this.loading = false;
      this.$bus.$emit("closeDialogEnviarProgramacion");
    },

    async enviarProgramacion() {
      try {
        this.$confirm(
          "¿Esta seguro(a) de enviar la programación de vacaciones de este funcionario? Puede que no haya terminado de programar todos los días",
          async () => {
            this.loading = true;
            await this.$query.add("estado_vacacion_observacion", {
              id_estado_vacacion: this.form.id_estado_vacacion,
              observacion: this.form.observacion,
              id_estado: 1,
              _user_created: this.user.id,
              _created_at: new Date()
            });
            let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select vacaciones.fn_envia_vacacion_inmediato_superior(${this.form.id_estado_vacacion},${this.user.id})"){
                respuesta
                }
              }
              `
            });
            let resp =
              respuesta.runQuery.respuesta[0]
                .fn_envia_vacacion_inmediato_superior;
            let resps = resp.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$alert("La programación fue enviada exitosamente", () => {
                this.close();
              });
            } else {
              this.$alert(resps[1], () => {});
              this.close();
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/EnviarProgramacion.vue